// PlantNotesColumns.js
import React from "react";
import dayjs from "dayjs";
import { I18n } from "aws-amplify/utils";

// Updated formatTimestamp to show "YYYY-MM-DD HH"
const formatTimestamp = (timestamp) => dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss");

export const PlantNotesColumns = () => [
  {
    id: "timestamp",
    label: I18n.get("Timestamp"),
    align: "left",
    flex: 1,
    renderCell: (params) => formatTimestamp(params.value), // Uses updated formatTimestamp
  },
  {
    id: "note",
    label: I18n.get("Note"),
    align: "left",
    flex: 1,
  },
  {
    id: "executor",
    label: I18n.get("Executor"),
    align: "left",
    flex: 1,
  },

  {
    id: "pinned",
    label: I18n.get("Pinned"),
    align: "left",
    flex: 1,
  },
  {
    id: "action",
    label: I18n.get("Action"),
    align: "left",
    flex: 1,
  },
];

export const DeviceNotesColumns = () => [
  {
    id: "timestamp",
    label: I18n.get("Timestamp"),
    align: "left",
    flex: 1,
    renderCell: (params) => formatTimestamp(params.value),
  },
  {
    id: "note",
    label: I18n.get("Note"),
    align: "left",
    flex: 1,
  },
  {
    id: "alarm_type_description",
    label: I18n.get("Alarm Type Description"),
    align: "left",
    flex: 1,
  },
  {
    id: "executor",
    label: I18n.get("Executor"),
    align: "left",
    flex: 1,
  },
  {
    id: "original_equipment",
    label: I18n.get("Original Equipment"),
    align: "left",
    flex: 1,
  },
  {
    id: "pinned",
    label: I18n.get("Pinned"),
    align: "left",
    flex: 1,
  },
  {
    id: "action",
    label: I18n.get("Action"),
    align: "left",
    flex: 1,
  },
];
export const DeviceNotesAlarmsColumns = () => [
  {
    id: "timestamp",
    label: I18n.get("Timestamp"),
    align: "left",
    flex: 1,
    renderCell: (params) => formatTimestamp(params.value),
  },
  {
    id: "note",
    label: I18n.get("Note"),
    align: "left",
    flex: 1,
  },
  {
    id: "alarm_type_description",
    label: I18n.get("Alarm Type Description"),
    align: "left",
    flex: 1,
  },
  {
    id: "executor",
    label: I18n.get("Executor"),
    align: "left",
    flex: 1,
  },
  {
    id: "pinned",
    label: I18n.get("Pinned"),
    align: "left",
    flex: 1,
  },
  {
    id: "action",
    label: I18n.get("Action"),
    align: "left",
    flex: 1,
  },
];
export const ProcessNotesAlarmsColumns = () => [
  {
    id: "timestamp",
    label: I18n.get("Timestamp"),
    align: "left",
    flex: 1,
    renderCell: (params) => formatTimestamp(params.value),
  },
  {
    id: "process_note",
    label: I18n.get("Process Note"),
    align: "left",
    flex: 1,
  },
  {
    id: "type",
    label: I18n.get("Type"),
    align: "left",
    flex: 1,
  },
  {
    id: "original_equipment",
    label: I18n.get("Original Equipment"),
    align: "left",
    flex: 1,
  },
  {
    id: "alarm_type_description",
    label: I18n.get("Alarm Type Description"),
    align: "left",
    flex: 1,
  },
  {
    id: "executor",
    label: I18n.get("Executor"),
    align: "left",
    flex: 1,
  },
];
export const ProcessNotesAlarmsColumnsAlarm = () => [
  {
    id: "timestamp",
    label: I18n.get("Timestamp"),
    align: "left",
    flex: 1,
    renderCell: (params) => formatTimestamp(params.value),
  },
  {
    id: "process_note",
    label: I18n.get("Process Note"),
    align: "left",
    flex: 1,
  },
  {
    id: "type",
    label: I18n.get("Type"),
    align: "left",
    flex: 1,
  },
  {
    id: "alarm_type_description",
    label: I18n.get("Alarm Type Description"),
    align: "left",
    flex: 1,
  },
  {
    id: "executor",
    label: I18n.get("Executor"),
    align: "left",
    flex: 1,
  },
];
